import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "./styles.css";
import { Mail } from "lucide-react";
import ClipLoader from "react-spinners/ClipLoader";
import { ButtonStylized, ButtonStylizedType } from "../ButtonStylized/ButtonStylized";
import { sendMagicLink, logger } from "@mental-mint/shared-utils";

const EmailListSignup = () => {
  const { register, handleSubmit, reset } = useForm({
    defaultValues: { email: "" }
  });
  const [subscriptionResultMsg, setSubscriptionResultMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  interface EmailFormData {
    email: string;
  }

  const onSubmit = async (data: EmailFormData): Promise<void> => {
    setIsLoading(true);
    logger.debug("Sending signup magic link:", data.email);

    try {
      // Send magic link with consent enabled for email reminders
      // gameId omitted - defaults to landing page
      await sendMagicLink(
        data.email,
        undefined, // gameId - undefined means landing page
        window.location.href, // returnUrl - return to current page after verification
        true // consentToReminders - user is signing up for emails
      );

      setSubscriptionResultMsg("✔️ You're signed up!");
      reset(); // Clears the input field
    } catch (error) {
      logger.error("Error sending signup email:", error);
      setSubscriptionResultMsg("❌ Error. Please try again.");
    } finally {
      setIsLoading(false);
      setTimeout(() => {setSubscriptionResultMsg("")}, 5000); // Clear message after 5 seconds
    }
  };

  return (
    <div className="email-signup-container">
      <form onSubmit={handleSubmit(onSubmit)} style={{width: "100%"}}>
        <input
          type="email"
          placeholder="Enter your email"
          {...register("email", { required: true })}
          defaultValue=""
          style={{
            width: "100%",
            borderRadius: "12px",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            background: "rgba(255, 255, 255, 0.05)",
            color: "#ffffff",
            fontSize: "1rem",
            height: "48px",
            padding: "0 1rem",
            pointerEvents: "auto",
            marginBottom: '0.75rem',
            transition: 'all 0.3s ease',
            backdropFilter: 'blur(10px)'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = 'rgba(16, 185, 129, 0.5)';
            e.target.style.background = 'rgba(255, 255, 255, 0.08)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
            e.target.style.background = 'rgba(255, 255, 255, 0.05)';
          }}
        />
        <ButtonStylized 
            buttonType={isLoading ? ButtonStylizedType.Disabled : ButtonStylizedType.Primary}
            buttonHtmlType="submit"
            icon={isLoading ? <ClipLoader color="white" loading={isLoading} size={20} />
              : subscriptionResultMsg ? null
              : <Mail size={24} strokeWidth={2} />}
            text={isLoading ? "Sending..."
              : subscriptionResultMsg ? subscriptionResultMsg 
              : "Subscribe"}
            additionalStyles={{ 
              fontSize:'1.1rem', 
              padding: '0.75rem 1.5rem', 
              height: '48px', 
              width: '100%',
              borderRadius: '12px',
              fontWeight: 300
            }}
        />
      </form>
    </div>
  );
};

export default EmailListSignup;
